import React from 'react'
import PropTypes from 'prop-types'

import ProductAnalyticsNavGuest from './Components/ProductAnalyticsNavGuest'
import ProductAnalyticsAbout from './Components/ProductAnalyticsAbout'
import ProductAnalytics from './ProductAnalytics'

class ProductAnalyticsGuest extends React.Component {
  componentDidMount() {
    const staticPlaceholder = document.getElementsByClassName('js-product-analytics-static')[0]

    if (staticPlaceholder && staticPlaceholder.parentNode) {
      staticPlaceholder.parentNode.removeChild(staticPlaceholder)
    }
  }

  render() {
    return (
      <div>
        <ProductAnalyticsNavGuest />
        <div className="tabs-content">
          <div className="tab-pane is-active">
            <ProductAnalyticsAbout analyticsParticipant={false} guestVersion signedIn={this.props.signedIn} />
          </div>
        </div>
      </div>
    )
  }
}

ProductAnalytics.propTypes = {
  signedIn: PropTypes.bool.isRequired,
}

export default ProductAnalyticsGuest
